import {toast} from "react-toastify";
// @ts-ignore
import {RecaptchaProvider} from "../internal/RecaptchaProvider";
import {useRecaptchaVerify} from "../hooks/UseRecaptchaVerify";
import {ReactNode} from "react";
import {EnvelopeIcon} from '@heroicons/react/24/outline'
import {useRouter} from "next/router";
import dynamic from "next/dynamic";


export default function ProjectContactForm(props: any) {
    return <RecaptchaProvider>
        <WrappedProjectContactForm {...props} />
    </RecaptchaProvider>
}

interface IProps {
    defaultMessage: string,
    formImage: ReactNode
}

const WrappedProjectContactForm = (
    {
        defaultMessage,
        formImage
    }: IProps) => {

    const {handleReCaptchaVerify} = useRecaptchaVerify();
    const router = useRouter();

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        // handleReCaptchaVerify().then(token => {

            const form = new FormData(e.target as HTMLFormElement);

            const parsedData = Object.fromEntries(form.entries());

            fetch("/api/contactmail", {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    firstName: `${parsedData.firstName}`,
                    lastName: `${parsedData.lastName}`,
                    email: parsedData.email,
                    phone: parsedData.phone,
                    message: parsedData.message + '\n\nExpected Budget: ' + parsedData.budget,
                    company: parsedData.company,
                    // recaptcha: token
                })
            }).then((res: any) => {
                if (res.status === 200) {
                    toast('Thank you for your message. We will get back to you as soon as possible.', {
                        type: 'success',
                        position: 'bottom-right'
                    });

                    //@ts-ignore
                    // window.gtag('event', 'conversion', {'send_to': 'AW-10838573329/wHYkCMGGhJkZEJGCnrAo'});

                    router.push('/success')
                } else {
                    toast('Sorry, something went wrong. Please try again later.', {
                        type: 'error',
                        position: 'bottom-right'
                    });
                }
            }).catch((err: any) => {
                toast('Sorry, something went wrong. Please try again later.', {
                    type: 'error',
                    position: 'bottom-right'
                });
            });
        // })

    }

    return <div className="relative bg-white mt-24">
        <div className={'max-w-7xl mx-auto lg:grid lg:grid-cols-2 gap-4 lg:gap-8'}>

            <div className="">
                <div className="">
                    <div className="">
                        <h2 className="text-4xl font-bold tracking-tight text-gray-900">Let&apos;s work together!</h2>
                        <p className="mt-2 text-lg leading-8 text-gray-600">
                            Get a more detailed quote for your project.
                        </p>
                        <form action="components/project-calculator/ProjectContactForm#" method="POST" className="mt-16"
                              onSubmit={handleSubmit}
                        >

                            <div className="grid grid-cols-1 gap-y-6 gap-x-8 sm:grid-cols-2">
                                <div>
                                    <label htmlFor="first-name"
                                           className="block text-sm font-semibold leading-6 text-gray-900">
                                        First name
                                    </label>
                                    <div className="mt-2.5">
                                        <input
                                            type="text"
                                            name="firstName"
                                            id="first-name"
                                            autoComplete="given-name"
                                            className="block w-full rounded-md border-0 py-2 px-3.5 text-sm leading-6 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-amber-300 outline-0"
                                        />
                                    </div>
                                </div>
                                <div>
                                    <label htmlFor="last-name"
                                           className="block text-sm font-semibold leading-6 text-gray-900">
                                        Last name
                                    </label>
                                    <div className="mt-2.5">
                                        <input
                                            type="text"
                                            name="lastName"
                                            id="last-name"
                                            autoComplete="family-name"
                                            className="block w-full rounded-md border-0 py-2 px-3.5 text-sm leading-6 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-amber-300 outline-0"
                                        />
                                    </div>
                                </div>
                                <div className="sm:col-span-2">
                                    <label htmlFor="email"
                                           className="block text-sm font-semibold leading-6 text-gray-900">
                                        Email
                                    </label>
                                    <div className="mt-2.5">
                                        <input
                                            id="email"
                                            name="email"
                                            type="email"
                                            autoComplete="email"
                                            className="block w-full rounded-md border-0 py-2 px-3.5 text-sm leading-6 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-amber-300 outline-0"
                                        />
                                    </div>
                                </div>
                                <div className="sm:col-span-2">
                                    <label htmlFor="company"
                                           className="block text-sm font-semibold leading-6 text-gray-900">
                                        Company
                                    </label>
                                    <div className="mt-2.5">
                                        <input
                                            type="text"
                                            name="company"
                                            id="company"
                                            autoComplete="organization"
                                            className="block w-full rounded-md border-0 py-2 px-3.5 text-sm leading-6 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-amber-300 outline-0"
                                        />
                                    </div>
                                </div>
                                <div className="sm:col-span-2">
                                    <div className="flex justify-between text-sm leading-6">
                                        <label htmlFor="phone" className="block font-semibold text-gray-900">
                                            Phone
                                        </label>
                                        <p id="phone-description" className="text-gray-400">
                                            Optional
                                        </p>
                                    </div>
                                    <div className="mt-2.5">
                                        <input
                                            type="tel"
                                            name="phone"
                                            id="phone"
                                            autoComplete="tel"
                                            aria-describedby="phone-description"
                                            className="block w-full rounded-md border-0 py-2 px-3.5 text-sm leading-6 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-amber-300 outline-0"
                                        />
                                    </div>
                                </div>
                                <div className="sm:col-span-2">
                                    <div className="flex justify-between text-sm leading-6">
                                        <label htmlFor="message"
                                               className="block text-sm font-semibold leading-6 text-gray-900">
                                            How can we help you?
                                        </label>
                                        <p id="message-description" className="text-gray-400">
                                            Max 500 characters
                                        </p>
                                    </div>
                                    <div className="mt-2.5">
        <textarea
            id="message"
            name="message"
            rows={10}
            aria-describedby="message-description"
            className="block w-full rounded-md border-0 py-2 px-3.5 text-sm leading-6 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-amber-300 outline-0"
            defaultValue={defaultMessage}
        />
                                    </div>
                                </div>
                                <fieldset className="sm:col-span-2">
                                    <legend className="block text-sm font-semibold leading-6 text-gray-900">Expected
                                        budget
                                    </legend>
                                    <div className="mt-4 space-y-4 text-sm leading-6 text-gray-600">
                                        <div className="flex gap-x-2.5">
                                            <input
                                                id="budget-under-25k"
                                                name="budget"
                                                defaultValue="under_25k"
                                                type="radio"
                                                className="mt-1 h-4 w-4 border-gray-300 text-indigo-600 shadow-sm focus:ring-amber-300"
                                            />
                                            <label htmlFor="budget-under-25k">Less than $25K</label>
                                        </div>
                                        <div className="flex gap-x-2.5">
                                            <input
                                                id="budget-25k-50k"
                                                name="budget"
                                                defaultValue="25k-50k"
                                                type="radio"
                                                className="mt-1 h-4 w-4 border-gray-300 text-indigo-600 shadow-sm focus:ring-amber-300"
                                            />
                                            <label htmlFor="budget-25k-50k">$25K – $50K</label>
                                        </div>
                                        <div className="flex gap-x-2.5">
                                            <input
                                                id="budget-50k-100k"
                                                name="budget"
                                                defaultValue="50k-100k"
                                                type="radio"
                                                className="mt-1 h-4 w-4 border-gray-300 text-indigo-600 shadow-sm focus:ring-amber-300"
                                            />
                                            <label htmlFor="budget-50k-100k">$50K – $100K</label>
                                        </div>
                                        <div className="flex gap-x-2.5">
                                            <input
                                                id="budget-over-100k"
                                                name="budget"
                                                defaultValue="over_100k"
                                                type="radio"
                                                className="mt-1 h-4 w-4 border-gray-300 text-indigo-600 shadow-sm focus:ring-amber-300"
                                            />
                                            <label htmlFor="budget-over-100k">$100K+</label>
                                        </div>
                                        <div className="flex gap-x-2.5">
                                            <input
                                                id="budget-na"
                                                name="budget"
                                                defaultValue="over_100k"
                                                type="radio"
                                                className="mt-1 h-4 w-4 border-gray-300 text-indigo-600 shadow-sm focus:ring-amber-300"
                                            />
                                            <label htmlFor="budget-na">Don&apos;t know yet</label>
                                        </div>
                                    </div>
                                </fieldset>
                            </div>
                            <div className="mt-10 flex justify-end border-t border-gray-900/10 pt-8">
                                <button
                                    type="submit"
                                    className="rounded-md btn-primary px-4 py-2 flex items-center block w-full text-center justify-center"
                                >
                                    Submit
                                    <EnvelopeIcon className={'ml-2 h-5 w-5'}/>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className="overflow-hidden hidden lg:block relative">
                {formImage}
            </div>
        </div>
    </div>

}